import { loader } from 'graphql.macro';
import { useQuery } from '@apollo/client';
import { get } from 'lodash';

import { useNotificationContext } from '../context/notification-context';
import { UserType } from '../definitions.d';

const USER_QUERY = loader('../graphql/user.graphql');

interface Response {
  user?: UserType;
  loading?: boolean;
  error?: Error;
}

const useUserQuery = (uuid: string): Response => {
  const { showNotification } = useNotificationContext();
  const { data, loading, error } = useQuery(USER_QUERY, {
    variables: { uuid },
    fetchPolicy: 'network-only',
    onError: (e) => {
      showNotification(e.message, 'error');
    }
  });
  return { user: get(data, 'user'), loading, error };
};

export default useUserQuery;
